import AvsCvv from './AvsCvv'

export default AvsCvv
